import React, { useMemo } from 'react'
import useLocationContractCyclesTabs from './hooks/useLocationContractCyclesTabs';
import { getBracketsText } from '../../../ContractScreensView/utils/getBracketsText';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import { TabButton } from '../../../ContractScreensView/components/TabButton';
import { LocationContractCyclesTabsProps } from './interfaces';
import Delimiter from '../../../../components/Delimiter/Delimiter';

const LocationContractCyclesTabs: React.FC<LocationContractCyclesTabsProps> = ({ tabStatePayload })  => {
  const { activeCycles, inactiveCycles, completedCycles, activeTab, onChangeTab } =
    useLocationContractCyclesTabs({ tabStatePayload });

  const activeText = useMemo(() => {
    if (activeCycles === null) {
      return '';
    }

    return getBracketsText(activeCycles);
  }, [activeCycles]);

  const inactiveText = useMemo(() => {
    if (inactiveCycles === null) {
      return '';
    }

    return getBracketsText(inactiveCycles);
  }, [inactiveCycles]);

  const completedText = useMemo(() => {
    if (completedCycles === null) {
      return '';
    }

    return getBracketsText(completedCycles);
  }, [completedCycles]);

  const onClickInactiveHandler = () => {
    onChangeTab(TAB_NUMBER.INACTIVE);
  };

  const onClickActiveHandler = () => {
    onChangeTab(TAB_NUMBER.ACTIVE);
  };

  const onClickCompletedHandler = () => {
    onChangeTab(TAB_NUMBER.COMPLETED);
  };

  return (
    <div className='c-location-contract-cycles-tabs'>
      <Delimiter className='mb-2 h-[1px] bg-foggy-mist' />
      <div className={'c-button-group grid auto-cols-fr xsm:grid-flow-col gap-x-3 gap-y-2 pb-4'}>
        <TabButton
          text={`Inactive ${inactiveText}`}
          onClick={onClickInactiveHandler}
          isActive={activeTab === TAB_NUMBER.INACTIVE}
        />
        <TabButton
          text={`Active ${activeText}`}
          onClick={onClickActiveHandler}
          isActive={activeTab === TAB_NUMBER.ACTIVE}
        />
        <TabButton
          text={`Completed ${completedText}`}
          onClick={onClickCompletedHandler}
          isActive={activeTab === TAB_NUMBER.COMPLETED}
        />
      </div>
    </div>
  );
};

export default LocationContractCyclesTabs;
